import { render, staticRenderFns } from "./field.vue?vue&type=template&id=d5038ca0&scoped=true&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=d5038ca0&prod&scoped=true&lang=css&"
import style1 from "./field.vue?vue&type=style&index=1&id=d5038ca0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5038ca0",
  null
  
)

export default component.exports